/**
 * 간단한 쿠키 유틸리티
 * 서버/클라이언트 환경을 고려한 쿠키 관리
 */

/**
 * 쿠키 크기 모니터링 (클라이언트 전용)
 */
export const getCookieStats = () => {
  if (typeof document === 'undefined') {
    return { totalSize: 0, cookieCount: 0, largestCookie: { name: '', size: 0 } }
  }

  const cookies = document.cookie
    .split(';')
    .map((cookie) => {
      const [name, value] = cookie.trim().split('=')
      return { name: name || '', size: cookie.length, value: value || '' }
    })
    .filter((c) => c.name)

  const largestCookie = cookies.reduce((largest, cookie) => (cookie.size > largest.size ? cookie : largest), {
    name: '',
    size: 0,
  })

  return {
    totalSize: document.cookie.length,
    cookieCount: cookies.length,
    largestCookie,
    cookies: cookies.map((c) => ({ name: c.name, size: c.size })),
  }
}

/**
 * 쿠키 크기 로깅 (개발 환경에서만)
 */
export const logCookieStats = () => {
  if (process.env.NODE_ENV !== 'development') return

  const stats = getCookieStats()
  console.log('🍪 Cookie Stats:', {
    totalSize: `${stats.totalSize} bytes (${(stats.totalSize / 1024).toFixed(2)} KB)`,
    cookieCount: stats.cookieCount,
    largestCookie: `${stats.largestCookie.name}: ${stats.largestCookie.size} bytes`,
    limit: '8KB (8192 bytes)',
  })

  if (stats.totalSize > 8192) {
    console.warn('⚠️ Cookie total size exceeds 8KB limit!', {
      current: stats.totalSize,
      limit: 8192,
    })
  }
}

/**
 * 쿠키 정리 (로그아웃 시)
 */
export const cleanupTempCookies = () => {
  if (typeof document === 'undefined') return

  const tempCookies = [
    'isSignin',
    'signInAuthType',
    'kakaoAccessToken',
    'return_url',
    'oauth_recaptcha_token',
    'oauth_recaptcha_action',
  ]

  tempCookies.forEach((name) => {
    document.cookie = `${name}=; Max-Age=0; Path=/;`
  })

  console.log('🧹 Cleaned up temporary cookies')
}
